import IMask from "imask";

const masks = document.querySelectorAll("[data-mask]");

const maskOptions = {
    mask: "+000 000 000 000 000",
    lazy: true
};

if (masks.length) {
    masks.forEach(mask => {
        if (mask.dataset.mask.length > 0) {
            IMask(mask, {
                mask: mask.dataset.mask
            });
        } else {
            IMask(mask, {
                mask: maskOptions
            });
        }
    });
}
